'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/index-blog');

require('../sections/index-content');

require('../sections/index-collections');

require('../sections/index-cta');

require('../sections/index-hero');

require('../sections/index-icons');

require('../sections/index-ingredients');

require('../sections/index-instagram');

require('../sections/index-products');

require('../sections/index-quiz-results');

(0, _themeSections.load)(['index-blog', 'index-content', 'index-collections', 'index-cta', 'index-hero', 'index-icons', 'index-ingredients', 'index-instagram', 'index-products', 'index-quiz-results']);